import { toQueryParams } from '@shared/utils/url';
import { v3 } from '@/api/client';
import { AgreementDocument, SignedAgreements } from './types';

export const fetchAgreementsById = (ids: string[]) =>
  v3.get<AgreementDocument[]>(`agreement/documents${toQueryParams({ ids })}`);

export const signAgreement = (documentIds: string[]) =>
  v3.post<void>(
    'agreement/sam/me/signatures',
    {
      documents: documentIds,
    },
    { responseType: 'void' }
  );

export const fetchSignedAgreements = () =>
  v3.get<SignedAgreements>('agreement/sam/me/signatures');
